import {
    postBillingCodeLoading,
    postBillingCodeRequest,
    postBillingCodeSuccess,
    postBillingCodeReject,
    postBillingCodeReset,
} from "../../actions/billingCode/post";

export const postBillingCode = (formData) => async (dispatch, getState) => {
    dispatch(postBillingCodeLoading());
    try {
        const { data } = await postBillingCodeRequest(formData, getState);
        dispatch(postBillingCodeSuccess(data))
    } catch (error) {
        dispatch(postBillingCodeReject(error))
    } finally {
        setTimeout(() => { dispatch(postBillingCodeReset()) }, 3000);
    }
    return Promise.resolve();
};
